/**
 * Created by renatolovizotto on 12/07/17.
 */
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import "../assets/stylesheets/DropdownFilter.scss";

@inject('Navigator', 'AuthStore', 'SchoolStore')
@observer
export default class DropdownLesson extends Component {

    /*
    ######################################
    # Change/Set LESSON -> Load STUDENTS #
    ######################################
    */
    handleChangeLesson(lessonSelected) {

        /*
            activity: "B3-R1-6"
            calendar_id: 2328
            created_at: 1512756646
            cycle: "B3"
            date_changed: null
            day: "2018-12-15"
            deleted_at: null
            id: 86939
            id_sf: "a1J360000062pgTEAQ"
            updated_at: 1528141491
        */

        //Busca SchoolStore
        var SchoolStore = this.props.SchoolStore;

        //Exibe Students
        SchoolStore.showStudents = true;

        //Seta Lesson Selecionada na Store
        SchoolStore.lessonSelected = lessonSelected;

        //Busca Objeto Inteiro da Class
        lessonSelected = this.props.SchoolStore.lessons[lessonSelected.value];

        this.props.SchoolStore.getStudentsByLesson(lessonSelected.id_sf);
        this.props.SchoolStore.msgAttendance = "";
    }

    render() {

        //Options do Select de Lessons
        if( this.props.SchoolStore.lessons != undefined){
            var optionsLessons = [];
            this.props.SchoolStore.lessons.forEach(lessonsToOptions);
            function lessonsToOptions(item, index) {

                    if(item.day != undefined ){
                        const formattedDate = item.day.split('-').reverse().join('/');
                        optionsLessons.push({ value: index, label: formattedDate + ' ' + item.lesson_name} );
                    }
                
            }
        }

        return (

            <Select
                name="lessons"
                options={optionsLessons}
                onChange={this.handleChangeLesson.bind(this)}
                placeholder="Selecione a aula"
                className="Dropdown"
                value={this.props.SchoolStore.lessonSelected}
            />

        );
        
    }

}


// WEBPACK FOOTER //
// ./src/containers/DropdownLesson.js